import { ReactNode, useEffect } from 'react';
import {
  ErrorBoundary as ReactErrorBoundary,
  ErrorBoundaryPropsWithFallback
} from 'react-error-boundary';
import { datadogRum } from '@datadog/browser-rum';
import { Container, Text, Wrapper } from './styled';

const ErrorFallback = () => (
  <Wrapper>
    <Container>
      <Text>
        An unforeseen error has occurred. Our technical staff has been notified
        and are working on a solution to the problem. You can try navigating
        back to the <br />
        <a href="/adhd-self-test">assessment page</a> to continue.
      </Text>
    </Container>
  </Wrapper>
);

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    datadogRum.setUser({
      id: `${Date.now()}`
    });
  }, []);

  const onError: ErrorBoundaryPropsWithFallback['onError'] = () => {
    datadogRum.setGlobalContextProperty('error_boundary', true);
  };

  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
